import React from "react";
import "./ProS.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";

class ProS extends React.Component {
    render() {
        return(
            <div>
                <Nav/>
                <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProS">01 Products</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Services"> 02 Services</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead14">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Our Products and Process</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>Lime Bricks and Blocks</p>
        <p className="text-justify">While working on Newmont Ghana Gold Ltd. Resettlement Project in Ghana from 2004 to 2013, the Green Building Expert and Entrepreneur Engr. Samuel Worwui saw how the indigenous farmers were living within the mining concession before they were relocated to their new resettlement site and discovered for himself the possibility of using local building material in a circular economy system in order to make the greatest impact environmentally, socially and economically.<nr/><br/>
        So disturbed with the distraction of the natural forest for the construction of new resettlement community using other unsustainable construction materials and technologies, he decided to develop a new sustainable construction materials and innovative construction technologies.
He started his research in late 2004, into sustainable construction material development and innovative construction technologies. Green Building and Circular economy became a passion for him and in 2017, he became an EDGE Expert and Auditor for IFC, The World Bank Group through Green Business Certification Inc., the certification and credentialing arm of the United States of American Green Building Council. 
<br/><br/>In the first quarter of 2019, the Green Building Expert and the entrepreneur finally discovered the solution for the best innovative sustainable composite construction material and technologies. 
He got together Ing. Dr. Emmanuel Appiah-Kubi, a Civil Engineer and Bamboo Expert; Ing. Dr. Anthony Andrews, a Materials Engineer; Dr. Edward Yeboah, a Soils and Biochar Expert and few other experts to develop the disruptive innovative Bamboo and Lime Bricks/Blocks Composite construction material and technologies, with the support of Carmeuse Lime Products Ghana Ltd.
He made his first mixes in his compound in third quarter of 2019 with the support of a team of an artisan and a technician form Carmuse Lime Products Ghana Ltd. The first ever Lime, Clay, Biochar, etc., Brick was produced and the Bamboo and Lime Bricks Composite small wall was built.
<br/><span style={{fontWeight: 'bold'}}>We have developed the technologies and have decided to begin with production soon.</span>
</p>
<div className="ml-5">
    <img src="https://i.imgur.com/Aol3Irj.jpg" alt="..."/>
</div>
<div className="row">
<div className="col-5">
<div class="card" style={{width: '100%'}}>
  <img src="https://i.imgur.com/nyWBiXO.jpg" class="card-img-top" alt="..."/>
  
</div>
   
</div>
<div className="col-6">
<div class="card" style={{width: '100%'}}>
  <img src="https://i.imgur.com/ah3RHoy.jpg" class="card-img-top" alt="..."/>
</div>
</div>
</div>
<h3 className="text-center mt-5" style={{margin: 0, fontWeight: 'bold'}}>Technology</h3>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>Comparison:</p>
            <ul>
                <li>•   It could be basically considered as a far relative of a sand-lime stone. </li>
                <li>•	 Its “thin soil” components make its basic composition comparable to a ceramic/fire clay brick, but it stays raw;</li>
                <li>•	Its process of hydraulic hardening makes it comparable to a concrete/cement block, but without the use of cement and sand; but with longer life-span, recyclable and carbon zero to negative; </li>
                <li>•	It is adapted to all shapes and sizes of bricks and blocks, for bearing walls (from 4 Mpa up to 40Mpa), soils and pavements, and other elements </li>
                <li>•	Depending on it is composition, its water and frost resistance are comparable to traditional concrete/cement blocks and ceramic/fire clay bricks;</li>
                <li>•	It is a much better material, in terms of sustainability, durability, water resistance and strength.</li>
            </ul>
            <p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>Specific advantages: </p>
            <ul>
                <li>•   Durability: 	Long-term hardening and absence of acidification, fire-resistance and fire retardant;  </li>
                <li>•   Comfort: 	Temperature, Moisture, Air and Sound regulation by the use of unfired clay, hydrated lime, etc.; </li>
                <li>•   Environment: Low footprint along the lifecycle, recyclability, no use of sand;</li>
                <li>• Aesthetic: 	Natural aspect.</li>
            </ul>
            <div className="col-12 mt-5">
                <img style={{width: '100%'}} src="https://i.imgur.com/P4OE2xj.jpg" alt="..."/>
            </div>
            <h3 className="text-center mt-5" style={{margin: 0, fontWeight: 'bold'}}>Production</h3>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<p style={{margin: 0, fontWeight: 'bold', marginTop: '5%'}}>Material and Process for Basic Hand-Made Production </p>
            <ul>
                <li>•   Self-made siever to sieve the laterite;  </li>
                <li>•	 Hand/mechanical brick/block press;</li>
                <li>•	Bamboo pallets and Bamboo sheets for storing and curing.</li>
            </ul>
</div>
</div>
</div>
</div>

            
        )
    }
}
export default withRouter(ProS);